module.exports = __webpack_public_path__ + "static/img/COC2023-10.74270ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-10.png
// module id = h5GY
// module chunks = 0